export enum NotesEnum {
  Career_Manager = 'CM',
  Capability_Lead = 'CAP_LEAD',
  PnT_Buddy = 'PNT',
}
